<template>
  <span class="debug" v-if="object != null">
    <template v-if="typeof object === 'object' || typeof object === 'array'">
      <span v-if="!open" @click="open = !open" class="button">&#9656;</span>
      <span v-if="open" @click="open = !open" class="button">&#9662;</span>
      <span>{{ object.length }}</span>
      <span v-if="Array.isArray(object)">[</span>
      <span v-else>{</span>
      <div v-show="open" v-for="(v, k) in object" :key="k">
        <template v-if="k == '_id' || (typeof k == 'string' && k.match('.*Id') && v)">
          {{ k }}: <router-link class="id" :to="{ name: 'ProjectObject', params: { _id: v } }">{{ v }}</router-link>
        </template>
        <template v-else> {{ k }}: <ProjectObjectItem :object="v" :level="level + 1" /> </template>
      </div>
      <span v-if="Array.isArray(object)">]</span>
      <span v-else>}</span>
    </template>
    <span v-else :class="[typeof object]">
      {{ object }}
    </span>
  </span>
</template>
<script>
import ProjectObjectItem from './ProjectObjectItem';

export default {
  name: 'ProjectObjectItem',
  data() {
    return {
      open: this.level <= 1,
    };
  },
  props: ['object', 'level'],
  components: {
    ProjectObjectItem,
  },
};
</script>

<style scoped>
.debug {
  margin-left: 5px;
  font-size: 8pt;
  text-align: left;
  display: inline-block;
  white-space: nowrap;
  vertical-align: top;
}

.number {
  color: rgb(93, 199, 93);
}
.string {
  color: rgb(55, 142, 182);
  white-space: normal;
}
.id {
  color: rgb(214, 172, 132);
  text-overflow: ellipsis;
}
.button {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/projectoverview/ProjectObjectItem.vue